import React, { useState } from 'react';
import './EditSchoolTeacher.css';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { updateUserFailure, updateUserStart, updateUserSuccess } from '../../../../../redux/registeredUserRedux';
import { userRequest } from '../../../../../requestMethod';
import { CalendarMonthOutlined, EmailOutlined, PermIdentity, PhoneOutlined, Publish } from '@mui/icons-material';
import { validateRequired } from '../../../../../formValidation';


const EditSchoolTeacher = () => {

    const location = useLocation();
    const schoolTeacherId = location.pathname.split('/')[2];
    // const isFetching = useSelector((state) => state.allUsers);
    const schoolTeacher = useSelector((state) => state.allUsers.users.find((item) => item._id === schoolTeacherId));

    const [firstName, setFirstName] = useState(schoolTeacher.firstName);
    const [lastName, setLastName] = useState(schoolTeacher.lastName);
    const [email, setEmail] = useState(schoolTeacher.email);
    const [phone, setPhone] = useState(schoolTeacher.phone);
    const [dateOfBirth, setDateOfBirth] = useState(schoolTeacher.dateOfBirth);
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [success, setSuccess] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
    const dispatch = useDispatch();

    // update action for school hod
    const updateUser = async (dispatch, schoolTeacherId, schoolTeacher) => {
        dispatch(updateUserStart());
        try {
            const res = await userRequest.put(`/user/${schoolTeacherId}`, schoolTeacher);
            if (res.status === 200) {
                setError(false);
                setSuccess(true);
                setSuccessMessage("HOD has been updated!");
            }
            dispatch(updateUserSuccess(res.data));

        } catch (error) {
            dispatch(updateUserFailure());
            if (error.response.status === 409) {
                setEmailError(true);
                setEmailErrorMessage(error.response.data);
            }

            else {
                setSuccess(false);
                setError(true);
                setErrorMessage("Something went wrong!");
            }
        }
    };

    // Validate function for form validation start=======
    const [errors, setErrors] = useState({});
    const validateForm = () => {
        let formIsValid = true;
        const newErrors = {};

        const firstNameValidErr = validateRequired(firstName);
        const lastNameValidErr = validateRequired(lastName);
        const emailValidErr = validateRequired(email);
        const phoneValidErr = validateRequired(phone);
        const dobValidErr = validateRequired(dateOfBirth);

        if (firstNameValidErr) {
            formIsValid = false;
            newErrors.firstName = firstNameValidErr;
        }
        if (lastNameValidErr) {
            formIsValid = false;
            newErrors.lastName = lastNameValidErr;
        }
        if (emailValidErr) {
            formIsValid = false;
            newErrors.email = emailValidErr;
        }
        if (phoneValidErr) {
            formIsValid = false;
            newErrors.phone = phoneValidErr;
        }
        if (dobValidErr) {
            formIsValid = false;
            newErrors.dateOfBirth = dobValidErr;
        }

        setErrors(newErrors);
        return formIsValid;
    }
    // Validate function for form validation end======

    const handleUpdate = () => {
        setSuccess(false);
        setError(false);

        if (validateForm()) {
            updateUser(dispatch, schoolTeacherId, { firstName, lastName, dateOfBirth, email, phone })
        }
    }


    return (
        <>
            <div className='container'>
                <div className='row mt-100'>
                    <div className="col-12">
                        <h2 className='page-heading mb-4 pl-4'>Update School Teacher</h2>
                    </div>
                    <div className="col-lg-4">
                        <div className="userShowWrapper">
                            <div className="userShowTop">
                                <div className="userShowImgWrapper">
                                    <img src={`${process.env.PUBLIC_URL}/Images/profile.jpg`} alt="userImg" />
                                </div>
                                <div className="userShowTopTitle">
                                    <div className="userShowUserName text-capitalize">{schoolTeacher.firstName + " " + schoolTeacher.lastName}</div>
                                    <div className="userShowUserDesignation">Teacher</div>
                                </div>
                            </div>
                            <div className="userShowBottom">
                                <span className="userShowBottomTitle">Account Details</span>
                                <div className="userShowBottomInfo">
                                    <PermIdentity className='userShowBottomInfoIcon' />
                                    <span className="userShowBottominfoTitle">{schoolTeacher.isSchoolTeacher ? "School Teacher" : "N.A."}</span>
                                </div>
                                <div className="userShowBottomInfo">
                                    <CalendarMonthOutlined className='userShowBottomInfoIcon' />
                                    <span className="userShowBottominfoTitle">{schoolTeacher.dateOfBirth}</span>
                                </div>
                                {/* <div className="userShowBottomInfo">
                                    <ApartmentIcon className='userShowBottomInfoIcon' />
                                    <span className="userShowBottominfoTitle">{schoolAdmin.schoolName}</span>
                                </div> */}
                                <span className="userShowBottomTitle">Contact Details</span>
                                <div className="userShowBottomInfo">
                                    <PhoneOutlined className='userShowBottomInfoIcon' />
                                    <span className="userShowBottominfoTitle">{schoolTeacher.phone}</span>
                                </div>
                                <div className="userShowBottomInfo">
                                    <EmailOutlined className='userShowBottomInfoIcon' />
                                    <span className="userShowBottominfoTitle">{schoolTeacher.email}</span>
                                </div>
                                {/* <div className="userShowBottomInfo">
                    <LocationOnOutlined className='userShowBottomInfoIcon' />
                    <span className="userShowBottominfoTitle">2607 S Rochester Rd United States</span>
                  </div> */}
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-8">
                        <div className="userUpdateWrapper">
                            <h2 className='userUpdateTitle'>Edit</h2>
                            <div className="row">
                                <div className="col-md-7">
                                    <div className="userUpdateLeft">
                                        <div className="userUpdateItem">
                                            <label>First Name</label>
                                            <input type="text" placeholder='meritus user' className='userUpdateInput' value={firstName} onChange={(e) => setFirstName(e.target.value)} />
                                            <span className='error-text'>{errors.firstName}</span>
                                        </div>
                                        <div className="userUpdateItem">
                                            <label>Last Name</label>
                                            <input type="text" placeholder='Moin Khan' className='userUpdateInput' value={lastName} onChange={(e) => setLastName(e.target.value)} />
                                            <span className='error-text'>{errors.lastName}</span>
                                        </div>
                                        <div className="userUpdateItem">
                                            <label>Email</label>
                                            <input type="text" placeholder='user@meritus.com' className='userUpdateInput' value={email} onChange={(e) => setEmail(e.target.value)} />
                                            <span className='error-text'>{errors.email}</span>
                                            {
                                                emailError && (
                                                    <p className='error-text text-danger'>{emailErrorMessage}</p>
                                                )
                                            }
                                        </div>
                                        <div className="userUpdateItem">
                                            <label>Phone</label>
                                            <input type="text" placeholder='9876543212' className='userUpdateInput' value={phone} onChange={(e) => setPhone(e.target.value)} />
                                        </div>
                                        <div className="userUpdateItem">
                                            <label>Date of Birth</label>
                                            <input type="date" className='userUpdateInput' value={dateOfBirth} onChange={(e) => setDateOfBirth(e.target.value)} />
                                            <span className='error-text'>{errors.dateOfBirth}</span>
                                        </div>
                                        {/* <div className="userUpdateItem">
                                            <label>School</label>
                                            <input type="text" className='userUpdateInput' value={schoolName} onChange={(e) => setSchoolName(e.target.value)} />
                                        </div> */}
                                        {/* <div className="userUpdateItem">
                        <label>Address</label>
                        <input type="text" placeholder='2607 S Rochester Rd United States' className='userUpdateInput' />
                      </div> */}
                                        <div className="col-12 mt-3">
                                            {
                                                success ? (
                                                    <div className='alert alert-success'>
                                                        {successMessage}
                                                    </div>
                                                ) : error && (
                                                    <div className='alert alert-danger'>
                                                        {errorMessage}
                                                    </div>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-5">
                                    <div className="userUpdateRight">
                                        <div className="userUpdateUpload">
                                            <div className="userUploadImgWrapper">
                                                <img src={`${process.env.PUBLIC_URL}/images/profile.jpg`} alt="" />
                                            </div>
                                            <label htmlFor="file"><Publish /></label>
                                            <input type="file" id='file' style={{ display: 'none' }} />
                                        </div>

                                        <div className="userUpdateButtonWrapper">
                                            <button className='btn btn-primary' onClick={handleUpdate}>Update</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default EditSchoolTeacher
